import { ReportProblemTwoTone } from '@mui/icons-material';
import { FC } from 'react';
import styles from './UnderConstructionPlaceholder.module.scss';

interface UnderConstructionPlaceholderProps {
    name?: string;
    explanation?: string;
}

const UnderConstructionPlaceholder: FC<UnderConstructionPlaceholderProps> = (
    props
) => (
    <div
        className={styles.UnderConstructionPlaceholder}
        data-testid="UnderConstructionPlaceholder"
    >
        <div className={styles.outerBox}>
            <div className={styles.mainBox}>
                <div className={styles.warningIconBox}>
                    <ReportProblemTwoTone className={styles.warningIcon} />
                </div>
                <h1>
                    {!!props.name
                        ? `${props.name} Is Under Construction`
                        : 'Under Construction'}
                </h1>
                {!!props.explanation ? <h2>{props.explanation}</h2> : null}
            </div>
        </div>
        <div className={styles.paddingBox} />
    </div>
);

export { UnderConstructionPlaceholder };
